import React from 'react'
import { connect } from 'react-redux'
import styles from './Home.module.css'
import orderBy from 'lodash/orderBy'
import {Header} from './Header'
import Spinner from './Spinner'
import add from '../images/add.svg'
import { Button, Input, FormGroup, Label } from 'reactstrap'
import { Dialog, DialogContent, DialogFooter, DialogHeader } from './Dialog'
import logo from '../images/wistor-mark-color.svg'
// @ts-expect-error
import { Helmet } from 'react-helmet'
import Footer from './Footer'
import { fetchProjects, createProject } from '../redux/projects'
import { useHistory } from 'react-router-dom'
import { useWistorAuth } from '../api/auth'
import { useSelector } from '../store'

type State = {
  dialogVisible: boolean,
  values: Partial<Record<'title' | 'path', string>>
}

function Home(props: {
  fetchProjects: typeof fetchProjects
  createProject: typeof createProject
}) {
  const [state, setState] = React.useState<State>({dialogVisible: false, values: {} })
  const store = useSelector(s => ({projects: s.projects}))
  const auth = useWistorAuth()
  const history = useHistory()

  const gotoLogin = () => history.push('/login', '')

  React.useEffect(() => {
    if (auth.status !== 'authorized') return gotoLogin()
    if (auth.user.role !== 'superadmin' && auth.user.project) {
      return history.replace(`/projects/${auth.user.project.path}`)
    }
    props.fetchProjects((error: any) => {
      if (error.response.status === 401) {
        history.push('/login', 'projects')
      }
    })
  }, [])

  const onDialogOkClick = () => {
    if (auth.status !== 'authorized') return gotoLogin()
    props.createProject(state.values, (error: any) => {
      if (error.response.status === 401) history.push('/login', 'projects')

    })
    setState(s => ({...s, dialogVisible: false }))
  }

  if (store.projects.loading) return <Spinner />
  if (!store.projects.loaded) return null

  let projects = store.projects.items
  // projects = orderBy(projects, ['createdAt'], ['asc']);
  // console.log(projects, role)
  projects = orderBy(projects, ['title'], ['asc'])
  return (
    <div>
      <Helmet>
        <title>Wistor</title>
        <link rel="icon" type="image/png" href="/favicon.png" sizes="16x16" />
      </Helmet>
      <Header />
      <div className={styles.mainContainer}>

        <div className={styles.main}>
          <div className={styles.content}>
            <img
              src={logo}
              alt="logo"
              style={{ maxHeight: '96px', margin: '0 12px 12px' }}
            />
            <div className={styles.title}>Welcome to Wistor</div>
            <p className={styles.paragr}>
                Data-centric working made easy
            </p>
            <div className={styles.subTitle}>Select a project:</div>
            <div className={styles.projects}>
              {projects.map((project: any) => {
                return (
                  <div
                    className={styles.project}
                    key={project.id}
                    onClick={() =>
                      history.push(`/projects/${project.path}`)
                    }
                  >
                    <div>{project.title}</div>
                  </div>
                )
              })}
              {auth.status === 'authorized' && auth.user?.role === 'superadmin' && (
                <div
                  className={styles.project}
                  onClick={() => setState(s => ({...s, dialogVisible: true }))}
                >
                  <div>
                    <img className="inline" src={add} alt="add" style={{ width: '24px' }} />
                    <span
                      style={{ verticalAlign: 'middle', paddingLeft: '12px' }}
                    >
                      Create a new project...
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>

      {state.dialogVisible && (
        <Dialog onClose={() => setState(s => ({ ...s, dialogVisible: false }))}>
          <DialogHeader title="Add project" />
          <DialogContent>
            <FormGroup>
              <Label>Title</Label>
              <Input
                name="title"
                className="dark-form-control"
                value={state.values.title || ''}
                type="text"
                onChange={(e) => setState(s => ({ ...s, values: { ...s.values, title: e.target.value } }))}
              />
            </FormGroup>
            <FormGroup>
              <Label>Path</Label>
              <Input
                name="path"
                className="dark-form-control"
                value={state.values.path || ''}
                type="text"
                onChange={(e) => setState(s => ({ ...s, values: { ...s.values, path: e.target.value } }))}
              />
            </FormGroup>
          </DialogContent>
          <DialogFooter>
            <Button
              color="secondary"
              style={{ minWidth: '120px' }}
              onClick={() => setState(s => ({...s, dialogVisible: false }))}
              aria-label="Cancel"
            >
              Cancel
            </Button>
            <Button
              color="primary"
              style={{ minWidth: '120px' }}
              onClick={onDialogOkClick}
              aria-label="OK"
            >
              OK
            </Button>
          </DialogFooter>
        </Dialog>
        )}
    </div>
)
}

export default connect(undefined, {
  fetchProjects, createProject
})(Home as any)
